import { useCallback, useState } from 'react';
import { useDebouncedCallback } from '@/hooks';

export type TFaqSearchFilters = {
  question?: string;
  answer?: string;
};

export const useFaqSearchFilters = (onSearch: (filters: TFaqSearchFilters) => void) => {
  const [filters, setFilters] = useState<TFaqSearchFilters>({ question: '', answer: '' });

  const debouncedSearch = useDebouncedCallback(onSearch, 500);

  const handleFilterChange = useCallback(
    (field: keyof TFaqSearchFilters, value: string) => {
      setFilters((prev) => {
        const next = { ...prev, [field]: value };
        debouncedSearch(next);
        return next;
      });
    },
    [debouncedSearch],
  );

  return { filters, handleFilterChange };
};
